import { useCallback } from "react";

const useExportCSV = () => {
  const exportToCSV = useCallback(
    (
      data,
      typeOptions,
      statusOptions,
      sortOptions,
      filename = "roadmap-data.csv"
    ) => {
      if (!data || data.length === 0) {
        console.warn("No data available for export");
        return;
      }

      try {
        const headers = [
          "ID",
          "Title",
          "Description",
          "User Name",
          "User Email",
          "Type",
          "Priority",
          "Status",
          "Votes Count",
          "Assigned To",
          "Updated By",
          "Created At",
          "Updated At",
        ];

        // Helper function: get label by value
        const getLabel = (options, value) => {
          const found = options?.find(
            (opt) => String(opt.value) === String(value)
          );
          return found ? found.label : value;
        };

        // Convert data to CSV rows
        const csvRows = data.map((item) => [
          item.id || "",
          `"${(item.title || "").replace(/"/g, '""')}"`,
          `"${(item.description || "").replace(/"/g, '""')}"`,
          `"${(item.user?.name || "").replace(/"/g, '""')}"`,
          item.user?.email || "",
          getLabel(typeOptions, item.type),
          getLabel(sortOptions, item.priority),
          getLabel(statusOptions, item.status),
          item.votesCount || "0",
          item?.assignedStaff?.name || "",
          item?.updated_by?.name || "",
          item.createdAt || "",
          item.updatedAt || "",
        ]);

        // Combine headers and rows
        const csvContent = [
          headers.join(","),
          ...csvRows.map((row) => row.join(",")),
        ].join("\n");

        // Create and trigger download
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);

        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error exporting CSV:", error);
      }
    },
    []
  );

  return { exportToCSV };
};

export default useExportCSV;
